module.exports = __webpack_public_path__ + "img/5-5.76e9d775.svg";